/**
 * Play Console and crawlers use ?lang=en on prerendered Arabic HTML.
 * Send them to dedicated English URLs that ship English in the first HTML.
 */
export default defineNuxtRouteMiddleware((to) => {
  if (queryLangValue(to.query.lang) !== 'en') return
  if (to.path.startsWith('/en/')) return

  const slug = to.path.replace(/^\/+|\/+$/g, '')
  if (slug === 'privacy' || slug === 'terms' || slug === 'delete-account') {
    return navigateTo(`/en/${slug}`, { redirectCode: 301 })
  }
})
